import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import OrderCreate from "../../components/Order/CreateOrder/OrderCreate";

const OrderCreateManualPage = (): ReactElement => {
  return (
    <Layout>
      <OrderCreate />
    </Layout>
  );
};

export default OrderCreateManualPage;
